import React from 'react';

const SpinnerComponent = ({ size, containterStyleInline }) => (
  <div className="spinner-container" style={{...containterStyleInline}}>
    <i className="fa fa-refresh fa-spin" style={{ fontSize: size }} />
  </div>
);

export default SpinnerComponent;



// WEBPACK FOOTER //
// src/components/SpinnerComponent.jsx